import { AbstractResource } from './AbstractResource';

export class Bindings extends AbstractResource {
    async get(gatewayId) {
        const { data } = await this.http.get(`/gateways/${gatewayId}/bindings`);
        return data;
    }

    async getOverride(gatewayId, customerId) {
        const { data } = await this.http.get(`/customer/${customerId}/gateways/${gatewayId}/override`);
        return data;
    }

    async save(gatewayId, dto) {
        const { data } = await this.http.post(`/gateways/${gatewayId}/bindings`, dto);
        return data;
    }

    async saveOverride(gatewayId, customerId, dto) {
        const { data } = await this.http.put(`/customer/${customerId}/gateways/${gatewayId}/override`, dto);
        return data;
    }

    async getGateways(gatewayId) {
        const { data } = await this.http.get(`/gateways/${gatewayId}/bindings/gateways`);
        return data;
    }

    async getCustomers(gatewayId, customerName) {
        const { data } = await this.http.get(`/gateways/${gatewayId}/bindings/customers`, { params: { customerName } });
        return data;
    }

    async getListings(gatewayFileId) {
        const { data } = await this.http.get(`/gateway-file/${gatewayFileId}/item`);
        return data;
    }

    async getListing(gatewayId, listingId) {
        const { data } = await this.http.get(`/gateways/${gatewayId}/bindings/listing/${listingId}`);
        return data;
    }
}